module.exports = __webpack_public_path__ + "static/chart-7aa1508570ad174d16a0f4668e164640.png";